import Guide from "../pages/guide";
import Button from "../pages/guide/button";
import Table from "../pages/guide/table";
import Form from "../pages/guide/form";
import Lottie from "../pages/guide/lottie-test";
import StampGuide from "../pages/guide/stamp";
import Chip from "../pages/guide/chip";
import Tabs from "../pages/guide/tabs";
import Popup from "../pages/guide/popup";
import Palette from "../pages/guide/palette";
import Divider from "../pages/guide/divider";
import Typography from "../pages/guide/typography";
import List from "../pages/guide/list";
import Title from "../pages/guide/title";
import TemplateForm from "../pages/guide/template-form";
import TemplateNodata from "../pages/guide/template-nodata";
import Switch from "../pages/guide/switch";

import Home from "../pages/home";
import Login from "../pages/login";
import Join from "../pages/join";
import JoinComplete from "../pages/join/complete";

//시스템관리
import CodeManagement from "pages/system-management/code-management";
import PermissionManagement from "pages/system-management/permission-management/index";
import MenuManagement from "pages/system-management/menu-management";
import DormantMemberManagement from "pages/system-management/dormant-member-management";
import PermissionLogManagement from "pages/system-management/permission-log-management";
import AccessLogManagement from "pages/system-management/access-log-management";
import AccessFailManagement from "pages/system-management/access-fail-management";
import AdminManagement from "pages/system-management/admin-management";
import NoticeManagement from "pages/customer-center-management/notice-management";
import FaqManagement from "pages/customer-center-management/faq-management";

import NoticeList from "pages/notice/list";
import NoticeDetail from "pages/notice/detail";
import Customer from "pages/customer";
import FaqList from "pages/faq/list";
import ShoppingMemo from "pages/shopping-memo";
import RecommendItem from "pages/recommend-item";

import Coupon from "pages/coupon";
import CouponDetail from "pages/coupon/detail";
import PasswordSearch from "pages/password/search";
import Stamp from "pages/stamp";
import StampDetail from "pages/stamp/detail";
import Event from "pages/event";
import EventDetail from "pages/event/detail";
import EventWinner from "pages/event/winner";
import Receipt from "pages/receipt";
import Point from "pages/point";

//마이페이지
import Mypage from "pages/mypage";
import Shopping from "pages/mypage/shopping";
import PointPassword from "pages/mypage/shopping/point-password";
import Cash from "pages/mypage/shopping/cash";
import Pay from "pages/mypage/shopping/pay";
import PaySign from "pages/mypage/shopping/pay/sign";

import Privacy from "pages/mypage/privacy";
import Leave from "pages/mypage/privacy/leave";
import Email from "pages/mypage/privacy/email";

//설정
import Setting from "pages/setting";
import Password from "pages/setting/password";
import Membership from "pages/membership";
import MembershipDetail from "pages/membership/detail";
import FavoriteStore from "pages/favorite-store";
import FavoriteStoreDetail from "pages/favorite-store/detail";
import RecommendItemDetail from "pages/recommend-item/detail";

import ProductOfWeek from "pages/product-of-week";
import ProductOfWeekDetail from "pages/product-of-week/detail";
import MyReview from "pages/my-review";
import MyReviewDetail from "pages/my-review/detail";

//Studio
import Studio from "pages/studio";
import Push from "pages/push";
import NotFound from "pages/not-found";
import LoadingGuide from "pages/guide/loading";
import Terms from "pages/terms";

const Routes = [
  // 홈
  {
    name: "Home",
    path: "/",
    component: Home,
  },
  // // 가이드페이지
  {
    name: "Guide",
    path: "/guide",
    component: Guide,
  },
  {
    name: "Button",
    path: "/guide/button",
    component: Button,
  },
  {
    name: "Form",
    path: "/guide/form",
    component: Form,
  },
  {
    name: "Table",
    path: "/guide/table",
    component: Table,
  },
  {
    name: "Tabs",
    path: "/guide/tabs",
    component: Tabs,
  },
  {
    name: "Popup",
    path: "/guide/popup",
    component: Popup,
  },
  {
    name: "Divider",
    path: "/guide/divider",
    component: Divider,
  },
  {
    name: "Switch",
    path: "/guide/switch",
    component: Switch,
  },
  {
    name: "Palette",
    path: "/guide/palette",
    component: Palette,
  },
  {
    name: "List",
    path: "/guide/list",
    component: List,
  },
  {
    name: "Typography",
    path: "/guide/typography",
    component: Typography,
  },
  {
    name: "Title",
    path: "/guide/title",
    component: Title,
  },
  {
    name: "Lottie",
    path: "/guide/lottie",
    component: Lottie,
  },
  {
    name: "Chip",
    path: "/guide/chip",
    component: Chip,
  },
  {
    name: "Stamp",
    path: "/guide/stamp",
    component: StampGuide,
  },
  {
    name: "Template-form",
    path: "/guide/template-form",
    component: TemplateForm,
  },
  {
    name: "Template-nodata",
    path: "/guide/template-nodata",
    component: TemplateNodata,
  },
  {
    name: "Loading",
    path: "/guide/loading",
    component: LoadingGuide,
  },
  {
    name: "코드관리",
    path: "/system-management/code-management",
    component: CodeManagement,
  },
  {
    name: "관리자권한관리",
    path: "/system-management/permission-management",
    component: PermissionManagement,
  },
  {
    name: "관리자메뉴관리",
    path: "/system-management/menu-management",
    component: MenuManagement,
  },
  {
    name: "휴면회원관리",
    path: "/system-management/dormant-member-management",
    component: DormantMemberManagement,
  },
  {
    name: "변경로그관리",
    path: "/system-management/permission-log-management",
    component: PermissionLogManagement,
  },
  {
    name: "접속로그관리",
    path: "/system-management/access-log-management",
    component: AccessLogManagement,
  },
  {
    name: "접속실패로그관리",
    path: "/system-management/access-fail-management",
    component: AccessFailManagement,
  },
  {
    name: "관리자관리",
    path: "/system-management/admin-management",
    component: AdminManagement,
  },
  {
    name: "공지사항관리",
    path: "/customer-management/notice-management",
    component: NoticeManagement,
  },
  {
    name: "자주묻는질문",
    path: "/customer-management/faq-management",
    component: FaqManagement,
  },
  {
    name: "쇼핑메모",
    path: "/shopping-memo",
    auth: true,
    component: ShoppingMemo,
  },
  {
    name: "추천상품",
    path: "/recommend-item",
    cache: true,
    component: RecommendItem,
  },
  {
    name: "추천상품 상세",
    path: "/recommend-item/detail",
    component: RecommendItemDetail,
  },
  {
    name: "추천상품 상세",
    path: "/recommend-item/detail/:seq",
    component: RecommendItemDetail,
  },
  {
    name: "쿠폰",
    path: "/coupon",
    auth: true,
    cache: true,
    component: Coupon,
  },
  {
    name: "쿠폰",
    path: "/coupon/detail",
    auth: true,
    component: CouponDetail,
  },
  {
    name: "스탬프",
    path: "/stamp",
    auth: true,
    cache: true,
    component: Stamp,
  },
  {
    name: "스탬프",
    path: "/stamp/detail",
    auth: true,
    component: StampDetail,
  },
  {
    name: "스탬프",
    path: "/stamp/detail/:seq",
    auth: true,
    component: StampDetail,
  },
  {
    name: "이벤트",
    path: "/event",
    cache: true,
    component: Event,
  },
  {
    name: "이벤트",
    path: "/event/:seq",
    component: EventDetail,
  },
  {
    name: "당첨자 발표",
    path: "/event/winner/:seq",
    component: EventWinner,
  },
  {
    name: "클럽",
    path: "/membership",
    auth: true,
    cache: true,
    component: Membership,
  },
  {
    name: "클럽 상세",
    path: "/membership/:cd",
    component: MembershipDetail,
  },
  {
    name: "단골매장",
    path: "/favorite-store",
    auth: true,
    cache: true,
    component: FavoriteStore,
  },
  {
    name: "단골매장 상세",
    path: "/favorite-store/detail",
    auth: true,
    component: FavoriteStoreDetail,
  },
  {
    name: "단골매장 상세",
    path: "/favorite-store/detail/:cd",
    auth: true,
    component: FavoriteStoreDetail,
  },
  {
    name: "영수증",
    path: "/receipt",
    auth: true,
    component: Receipt,
  },
  {
    name: "금주의 행사상품",
    path: "/product-of-week",
    cache: true,
    component: ProductOfWeek,
  },
  {
    name: "금주의 행사상품 상세",
    path: "/product-of-week/detail",
    component: ProductOfWeekDetail,
  },
  {
    name: "금주의 행사상품 상세",
    path: "/product-of-week/detail/:seq",
    component: ProductOfWeekDetail,
  },
  {
    name: "My 리뷰",
    path: "/my-review",
    auth: true,
    cache: true,
    component: MyReview,
  },
  {
    name: "My 리뷰 상세",
    path: "/my-review/detail",
    auth: true,
    component: MyReviewDetail,
  },
  {
    name: "My 리뷰 상세",
    path: "/my-review/detail/:seq",
    auth: true,
    component: MyReviewDetail,
  },
  {
    name: "포인트",
    path: "/point",
    auth: true,
    component: Point,
  },
  //megamart

  // 로그인
  {
    name: "로그인",
    path: "/login",
    component: Login,
  },
  {
    name: "간편비밀번호",
    path: "/password/search",
    component: PasswordSearch,
  },
  {
    name: "회원가입",
    path: "/join/complete",
    component: JoinComplete,
  },
  {
    name: "회원가입",
    path: "/join/:seq",
    component: Join,
  },
  {
    name: "공지사항",
    path: "/notice/list",
    cache: true,
    component: NoticeList,
  },
  {
    name: "공지사항",
    path: "/notice/detail/:seq",
    component: NoticeDetail,
  },
  {
    name: "고객센터",
    path: "/customer",
    component: Customer,
  },
  {
    name: "자주묻는질문",
    path: "/faq/list",
    component: FaqList,
  },
  {
    name: "마이페이지",
    path: "/mypage",
    auth: true,
    cache: true,
    component: Mypage,
  },
  {
    name: "쇼핑정보 관리",
    path: "/mypage/shopping",
    auth: true,
    component: Shopping,
  },
  {
    name: "포인트 비밀번호 변경",
    path: "/mypage/shopping/point-password",
    auth: true,
    component: PointPassword,
  },
  {
    name: "현금영수증 번호 등록",
    path: "/mypage/shopping/cash",
    auth: true,
    component: Cash,
  },
  {
    name: "간편결제 카드관리",
    path: "/mypage/shopping/pay",
    auth: true,
    component: Pay,
  },
  {
    name: "카드등록 서명",
    path: "/mypage/shopping/pay/sign",
    auth: true,
    component: PaySign,
  },
  {
    name: "카드등록 서명",
    path: "/mypage/shopping/pay/sign/:niceCid",
    auth: true,
    component: PaySign,
  },
  {
    name: "개인정보 수정",
    path: "/mypage/privacy",
    auth: true,
    component: Privacy,
  },
  {
    name: "개인정보 수정",
    path: "/mypage/privacy/email",
    auth: true,
    component: Email,
  },
  {
    name: "회원탈퇴",
    path: "/mypage/privacy/leave",
    auth: true,
    component: Leave,
  },
  // 설정
  {
    name: "설정",
    path: "/setting",
    auth: true,
    component: Setting,
  },
  {
    name: "간편비밀번호 설정",
    path: "/setting/password",
    auth: true,
    component: Password,
  },
  {
    name: "스튜디오M",
    path: "/studio",
    component: Studio,
  },
  { name: "알림함", auth: true, path: "/push", component: Push },
  { name: "에러 페이지", path: "/notFound", component: NotFound },
  { name: "약관", path: "/terms", component: Terms },
  { name: "약관", path: "/terms/:tp", component: Terms },
];
export default Routes;
